import { render, staticRenderFns } from "./AssetChartsStats.vue?vue&type=template&id=3db3637e&scoped=true&"
import script from "./AssetChartsStats.vue?vue&type=script&lang=js&"
export * from "./AssetChartsStats.vue?vue&type=script&lang=js&"
import style0 from "./AssetChartsStats.vue?vue&type=style&index=0&id=3db3637e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db3637e",
  null
  
)

/* custom blocks */
import block0 from "./AssetChartsStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports